import { NavigateWithSignature } from "@timeedit/registration-components";
import { ITEToken } from "@timeedit/registration-schemas";
import { customerPathFromSignature } from "@timeedit/registration-shared";
import { Navigate, RouteObject, createBrowserRouter } from "react-router-dom";
import { ErrorPage } from "./ErrorPage";
import { Root } from "./RootPage/Root";
import { getEndpoints } from "./RouteTypes";
import { childRoutes } from "./routes";

export function getRouter(
  authUser: ITEToken | undefined
): ReturnType<typeof createBrowserRouter> {
  const customerSignature = authUser?.customerSignature ?? "";
  const customerPath = customerPathFromSignature(customerSignature);
  const routes: RouteObject[] = [
    {
      path: `/${customerPath}`,
      element: <Root />,
      errorElement: <ErrorPage />,
      children: [
        {
          index: true,
          element: <Navigate to={getEndpoints().registration.path} />,
        },
        ...childRoutes,
      ].map((route) => ({ errorElement: <ErrorPage />, ...route })),
    },
    {
      path: "/*",
      element: (
        <NavigateWithSignature
          customerSignature={customerSignature}
          root={getEndpoints().registration.path}
        />
      ),
    },
  ];

  return createBrowserRouter(routes);
}
